<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/equipment/check/bill/item/page" getKey="rows" :columns="columns" :isShowPagination="false">
      <template #dianjianjieguo="scope">
        <template v-if="$attrs.equipment.status === 1">
          <!-- 未检点 -->
          <el-radio-group v-model="scope.row.result">
            <el-radio :label="1">{{ $t('hege') }}</el-radio>
            <el-radio :label="0">{{ $t('buhege') }}</el-radio>
          </el-radio-group>
        </template>
        <template v-if="$attrs.equipment.status === 2">
          <!-- 超期未点检 -->
          <el-radio-group v-model="scope.row.result"> </el-radio-group>
        </template>
        <template v-if="$attrs.equipment.status === 3">
          <!-- 已完成 -->
          {{ parseInt(scope.row.result) === 1 ? $t('hege') : $t('buhege') }}
        </template>
      </template>

      <template #top>
        <div style="display: flex;flex-direction: row;margin-right: 400px;">
          <el-descriptions :colon="false">
            <el-descriptions-item :label="$t('dianjiandanhao')">{{ $attrs.equipment.no }} </el-descriptions-item>
          </el-descriptions>
          <el-descriptions :colon="false">
            <el-descriptions-item :label="$t('shebeimingcheng')">{{ $attrs.equipment.equipment.name }} </el-descriptions-item>
          </el-descriptions>
        </div>
        <div>
          <el-descriptions :colon="false">
            <el-descriptions-item :label="$t('dianjianshijian')">{{ $attrs.equipment.planTime | formatTime }} </el-descriptions-item>
          </el-descriptions>
          <el-descriptions :colon="false" v-if="$attrs.equipment.status == 1">
            <el-descriptions-item :label="$t('beizhu')">
              <el-input size="mini" v-model="$attrs.equipment.remark"></el-input>
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions :colon="false" v-else-if="$attrs.equipment.status != 1 && $attrs.equipment.remark != null && $attrs.equipment.remark != ''">
            <el-descriptions-item :label="$t('beizhu')">
              {{ $attrs.equipment.remark }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </template>
    </yi_curd_table>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'web_equipment_check_check_list_item',
  data() {
    return {
      fixConditions: {
        billId: this.$attrs.equipment.id
      },
      status: [
        {
          label: this.$t('shi'),
          value: true
        },
        {
          label: this.$t('fou'),
          value: false
        }
      ],
      columns: [
        {
          label: 'dianjianfenzu',
          prop: 'group',
          width: 130
        },
        {
          label: 'dianjianneirong',
          prop: 'content'
        },
        {
          label: 'zhuyishixiang',
          prop: 'attention'
        },
        {
          label: 'dianjianjieguo',
          prop: 'result',
          width: 180,
          type: 'slot'
        }
      ]
    };
  },
  filters: {
    formatTime(value) {
      let date = new Date(value);
      let second = date.getSeconds() < 10 ? '0' + String(date.getSeconds()) : date.getSeconds();
      let minutes = date.getMinutes() < 10 ? '0' + String(date.getMinutes()) : date.getMinutes();
      let hours = date.getHours() < 10 ? '0' + String(date.getHours()) : date.getHours();
      return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + hours + ':' + minutes + ':' + second;
    }
  },
  created() {
    setTimeout(() => {
      this.yt.isShowPagination = false;
      this.yt.pageSize = 9999;
      this.yt.conditions = {
        billId: this.$attrs.equipment.id
      };
      this.yt.get(1);
    }, 300);
  },
  methods: {}
};
</script>

<style></style>
